import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';
import * as React from 'react';
import { Box } from '@wix/design-system';
import { Collapse } from '@wix/package-picker-components';
import { Experiments, PaymentCycle, Theme } from 'enums';
import { MonthlyDisclaimer } from '../MonthlyDisclaimer/MonthlyDisclaimer';
import { AscendBundleHelper } from './AscendBundleHelper';
import { YearlyBenefits } from '../YearlyBenefits/YearlyBenefits';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { RootStore, withInjectedRootStore } from 'providers';
import { RevShareHelper } from './RevShareHelper/RevShareHelper';
import { CycleDetails } from 'types';

interface CycleHelperProps extends InjectedExperimentsProps {
  cycle: CycleDetails;
  _disclaimerKey: string;
  isAscendBundle: boolean;
  features: any;
  showDisclaimer: boolean;
  isShown: boolean;
  rootStore: RootStore;
}

const CycleHelperComp: React.FC<CycleHelperProps> = ({
  cycle,
  isAscendBundle,
  features,
  showDisclaimer,
  isShown,
  experiments,
  rootStore,
}) => {
  const { theme } = usePageModeContext();
  const { cycleId } = cycle;
  const isAscendBundleEnabled = experiments.enabled(Experiments.AscendBundle);
  const isYearlyBenefitsEnabled = experiments.enabled(
    Experiments.YearlyBenefits,
  );
  const { isEligibleForRevShare } = rootStore.appStore;
  const isNotMonthly = cycleId !== PaymentCycle.MONTHLY;

  let helperToRender: React.ReactNode = null;

  if (theme === Theme.Dayful) {
    return null;
  }

  if (cycleId === PaymentCycle.MONTHLY && showDisclaimer) {
    helperToRender = <MonthlyDisclaimer missingFeatureList={features} />;
  } else if (isEligibleForRevShare) {
    helperToRender = <RevShareHelper cycle={cycle} />;
  } else if (isNotMonthly && isYearlyBenefitsEnabled) {
    helperToRender = <YearlyBenefits cycleId={cycleId} />;
  } else if (
    [PaymentCycle.YEAR2, PaymentCycle.YEAR3].includes(cycleId) &&
    isAscendBundleEnabled &&
    isAscendBundle
  ) {
    helperToRender = <AscendBundleHelper />;
  }

  if (helperToRender === null) {
    return null;
  }

  return (
    <Collapse
      isOpened={isShown}
      initialStyling={{
        width: '100%',
      }}
    >
      <Box
        margin='0 30px'
        paddingBottom={isShown ? '30px' : undefined}
        boxSizing='border-box'
      >
        {helperToRender}
      </Box>
    </Collapse>
  );
};

export const CycleHelper = withExperiments(
  withInjectedRootStore(CycleHelperComp),
);
